export const toNumber = (possible: any): number | undefined => {
    // null === 0 when converted so we want to drop that on the off chance
    if (possible === null || possible === undefined) {
      return undefined;
    }
  
    const asNum = Number(possible);
    return !isNaN(asNum) ? asNum : undefined;
  };
  